import type { ReadProjectSettlementsComments } from "@/schemas/projectSettlementsComments";
import type { CommentRead } from "@/schemas/comments";

export function mapProjectSettlementCommentsToCommentRead(
  items: ReadProjectSettlementsComments[],
): CommentRead[] {
  return items.map((item) => ({
    id: item.id,
    comment: item.comment,
    created_at: item.created_at,
    author_name: item.user_name,
    author_role_name: undefined,
  }));
}
